module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Road-Cone-d52cb9d6e67e2594cada534eb15cad58.svg";